@import url("https://fonts.googleapis.com/css2?family=Rajdhani:wght@500;600;700&display=swap");

.br,
.br *,
.br *::before,
.br *::after {
  box-sizing: border-box;
}

.br {
  position: relative;
  background: #ffffff;
  color: #0a0a0a;
  font-family: "Rajdhani", Arial, sans-serif;
  overflow: visible;
}

.br-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1fr);
  grid-template-rows: auto 1fr;
  column-gap: 5rem;
  row-gap: 1rem;
}

.br-header {
  grid-column: 2;
  grid-row: 1;
  max-width: 560px;
}

.br-body-wrap {
  grid-column: 2;
  grid-row: 2;
  max-width: 560px;
  align-self: start;
}

.br-visual {
  grid-column: 1;
  grid-row: 1 / -1;
  align-self: center;
  position: relative;
}

.br-callout {
  position: absolute;
  top: -2.5rem;
  left: 0;
  z-index: 10;
  max-width: 290px;
  padding: 0.95rem 1.1rem;
  border-radius: 10px;
  border: 1px solid rgba(10, 10, 10, 0.1);
  background: rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: 0 14px 32px rgba(10, 10, 10, 0.12);
}

.br-callout-label {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #de3431;
  margin-bottom: 0.4rem;
}

.br-callout-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #de3431;
  box-shadow: 0 0 10px rgba(222, 52, 49, 0.55);
}

.br-callout-text {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.45;
  color: #2a2a32;
  font-weight: 500;
}

.br-callout-text strong {
  color: #0a0a0a;
  font-weight: 700;
}

.br-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #de3431;
  margin-bottom: 1.75rem;
}

.br-eyebrow-mark {
  width: 28px;
  height: 2px;
  background: #de3431;
  border-radius: 2px;
  display: inline-block;
}

.br-title {
  margin: 0 0 1.75rem 0;
  font-weight: 700;
  font-size: clamp(2rem, 3.5vw, 2.5rem);
  letter-spacing: -0.025em;
  line-height: 1.1;
  color: #0a0a0a;
}

.br-title-accent {
  background: linear-gradient(135deg, #de3431 0%, #ff6b5a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.br-body {
  margin: 0 0 1.1rem 0;
  font-size: clamp(1rem, 1.1vw, 1.1rem);
  line-height: 1.6;
  color: #4a4a55;
  font-weight: 500;
}

.br-body-lead {
  font-size: clamp(1.08rem, 1.25vw, 1.25rem);
  line-height: 1.55;
  color: #2a2a32;
  font-weight: 500;
}

.br-body:last-child {
  margin-bottom: 0;
}

.br .br-image-frame {
  position: relative !important;
  width: 100% !important;
  margin: 0 auto !important;
  aspect-ratio: 19 / 20 !important;
  max-height: 500px !important;
  max-width: none !important;
  height: auto !important;
}

.br .br-color-image {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: contain !important;
  border-radius: 2px;
  transition: opacity 2s ease-in-out;
  will-change: opacity;
}

.br .br-shadow-image {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: contain !important;
  z-index: 0;
  pointer-events: none;
}


@media (max-width: 960px) {
  .br-inner {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 2rem;
    column-gap: 0;
  }
  .br-header {
    grid-column: 1;
    grid-row: auto;
    order: 1;
    max-width: none;
  }
  .br-visual {
    grid-column: 1;
    grid-row: auto;
    order: 2;
    padding: 0 15%;
  }
  .br-body-wrap {
    grid-column: 1;
    grid-row: auto;
    order: 3;
    max-width: none;
  }
  .br-image-frame {
    width: 100%;
    margin: 0 auto 0 0;
    max-height: 420px;
  }

  .br-callout {
    top: -1.25rem;
    left: 0;
    max-width: 260px;
  }
}

@media (max-width: 540px) {
  .br-title {
    font-size: clamp(1.9rem, 7vw, 2.5rem);
    margin-bottom: 1.25rem;
  }
  .br-eyebrow { margin-bottom: 1.25rem; }
  .br-image-frame { aspect-ratio: 4 / 3; }
  .br-visual { padding: 0 5%; }

  .br-callout {
    top: -0.75rem;
    max-width: calc(100% - 2rem);
    padding: 0.8rem 0.95rem;
  }
  .br-callout-text {
    font-size: 0.9rem;
  }
}
